import { __assign } from "tslib";
require('es6-shim'); //tslint:disable-line
import { ArticleType } from '@wix/answers-api';
import { PublicEventType } from '../public';
import { ensureAnonId, getAnonId } from '../utils/pseudonymous-id';
import { sanitizePII } from '@wix/bi-logger-sanitizer';
import { pageTypeMap, getCategoryData, getSearchResultIds, getFullTicketData, getBaseTicketData, maybeGetArticleId, createWixLogger, isWixTenant } from './wix-utils';
import { abTestConductionCheckEvent } from '@wix/bi-logger-ans-bi/v2';
import { publicClickContactUsFooter, publicNoSearchResults, publicPageView, publicPageViewArticle, publicPageViewCategory, publicPageViewError, publicPageViewTicket, publicSearch, publicSeeAllResults, publicSelectCategoryOrSubcategory, publicSelectSearchResult, publicSubmitTicketAttempt, publicSubmitTicketCancel, publicSubmitTicketSuccess, publicSubmitTicketValidationError, publicSuggestedArticlesClick, publicUserArticleEngagementPing, publicVoteForArticle, publicVoteForFeatureRequest, publicVoteForKnownIssue } from '@wix/bi-logger-wix-answers/v2';
export var createWixPublicHandler = function (baseData) {
    try {
        ensureAnonId();
    }
    catch (e) {
        // tslint:disable-next-line:no-console
        console.error('error creating wix client id', e);
    }
    var logger = createWixLogger({ trackSession: isWixTenant(baseData.tenantId) });
    var base = {
        locale: baseData.locale,
        referral_name: baseData.referralName,
        referral_url: sanitizePII(baseData.referralUrl),
        tenant_id: baseData.tenantId,
        user_id: baseData.userId,
        source_type: baseData.sourceType,
        source_id: baseData.sourceId,
        source_name: baseData.sourceName,
        client_id: getAnonId() || undefined
    };
    // tslint:disable-next-line: cyclomatic-complexity
    return function (event) {
        switch (event.type) {
            case PublicEventType.HOME_PAGE_LOAD:
            case PublicEventType.SEARCH_PAGE_LOAD:
            case PublicEventType.CONTACT_PAGE_LOAD:
            case PublicEventType.USER_PAGE_LOAD:
                return logger.report(publicPageView(__assign(__assign({}, base), { page_type: pageTypeMap[event.type] })));
            case PublicEventType.TICKET_PAGE_LOAD:
                logger.report(publicPageView(__assign(__assign({}, base), { page_type: 'ticket' })));
                return logger.report(publicPageViewTicket(__assign(__assign({}, base), { ticket_id: event.data.ticket.id })));
            case PublicEventType.ARTICLE_PAGE_LOAD: {
                var _a = event.data, article = _a.article, category = _a.category, subcategory = _a.subcategory;
                var articleData = __assign({ article_id: article.id, article_name: article.title, article_type: ArticleType[article.type] }, getCategoryData(category, subcategory));
                logger.report(publicPageView(__assign(__assign({}, base), { page_type: 'article' })));
                return logger.report(publicPageViewArticle(__assign(__assign({}, base), articleData)));
            }
            case PublicEventType.CATEGORY_PAGE_LOAD: {
                var _b = event.data, category = _b.category, subcategory = _b.subcategory;
                logger.report(publicPageView(__assign(__assign({}, base), { page_type: 'category' })));
                return logger.report(publicPageViewCategory(__assign(__assign({}, base), getCategoryData(category, subcategory))));
            }
            case PublicEventType.PAGE_LOAD_ERROR: {
                var _c = event.data, pageType = _c.pageType, reason = _c.reason, url = _c.url;
                return logger.report(publicPageViewError(__assign(__assign({}, base), { page_type: pageType, errorReason: reason, page_url: url })));
            }
            case PublicEventType.ARTICLE_WAS_HELPFUL:
            case PublicEventType.ARTICLE_WAS_NOT_HELPFUL:
                return logger.report(publicVoteForArticle(__assign(__assign({}, base), { thumbs_up: event.type === PublicEventType.ARTICLE_WAS_HELPFUL, article_id: event.data.article.id, category_id: event.data.article.categoryId })));
            case PublicEventType.VOTE_FOR_FEATURE:
            case PublicEventType.UNVOTE_FOR_FEATURE:
                return logger.report(publicVoteForFeatureRequest(__assign(__assign({}, base), { thumbs_up: event.type === PublicEventType.VOTE_FOR_FEATURE, article_id: event.data.article.id, category_id: event.data.article.categoryId })));
            case PublicEventType.VOTE_KNOWN_ISSUE:
            case PublicEventType.UNVOTE_KNOWN_ISSUE:
                return logger.report(publicVoteForKnownIssue(__assign(__assign({}, base), { thumbs_up: event.type === PublicEventType.VOTE_KNOWN_ISSUE, article_id: event.data.article.id, category_id: event.data.article.categoryId })));
            case PublicEventType.SEARCH: {
                if (event.data.results.count) {
                    var _d = event.data, results = _d.results, term = _d.term;
                    var searchResultsData = __assign(__assign({}, getSearchResultIds(results)), { search_term: term });
                    return logger.report(publicSearch(__assign(__assign({}, base), searchResultsData)));
                }
                else {
                    return logger.report(publicNoSearchResults(__assign(__assign({}, base), { search_term: event.data.term })));
                }
            }
            case PublicEventType.SEARCH_RESULT_SELECTED: {
                var _e = event.data, index = _e.index, term = _e.term, article = _e.article;
                var selectResultData = {
                    search_term: term,
                    answer_index: index,
                    article_id: article.id,
                    answer: article.title,
                    category_id: article.categoryId
                };
                return logger.report(publicSelectSearchResult(__assign(__assign({}, base), selectResultData)));
            }
            case PublicEventType.SEE_ALL_RESULTS: {
                var _f = event.data, results = _f.results, term = _f.term;
                var searchResultsData = __assign(__assign({}, getSearchResultIds(results)), { search_term: term });
                return logger.report(publicSeeAllResults(__assign(__assign({}, base), searchResultsData)));
            }
            case PublicEventType.HOME_CATEGORY_CLICKED:
            case PublicEventType.HOME_SUBCATEGORY_CLICKED: {
                var category = event.data.category;
                var categoryData = { category_id: category.id, category_name: category.name };
                return logger.report(publicSelectCategoryOrSubcategory(__assign(__assign({}, base), categoryData)));
            }
            case PublicEventType.CONTACT_US_CLICKED:
                return logger.report(publicClickContactUsFooter(base));
            case PublicEventType.SUBMIT_TICKET:
                return logger.report(publicSubmitTicketAttempt(__assign(__assign({}, base), getFullTicketData(event.data))));
            case PublicEventType.SUBMIT_TICKET_VALIDATION_ERROR: {
                var invalidFields = event.data.invalidFields;
                var validationErrorData = __assign(__assign({}, getFullTicketData(event.data)), { error_in_subject: invalidFields.title, error_in_description: invalidFields.description, error_in_name: invalidFields.name, error_in_email: invalidFields.email, error_in_costume_field: invalidFields.customFields });
                return logger.report(publicSubmitTicketValidationError(__assign(__assign({}, base), validationErrorData)));
            }
            case PublicEventType.SUBMIT_TICKET_SUCCESS: {
                var tciketSuccessData = __assign(__assign({}, getFullTicketData(event.data)), { ticket_id: event.data.ticketId });
                return logger.report(publicSubmitTicketSuccess(__assign(__assign({}, base), tciketSuccessData)));
            }
            case PublicEventType.SUBMIT_TICKET_CANCEL: {
                var submitTicketCancelData = __assign(__assign({}, getBaseTicketData(event.data)), { is_attached: !!event.data.attachments.length, article_id: maybeGetArticleId(event.data.sourceArticle) });
                return logger.report(publicSubmitTicketCancel(__assign(__assign({}, base), submitTicketCancelData)));
            }
            case PublicEventType.CONTACT_SUGGESTED_ARTICLE_CLICKED: {
                var articleSelectedData = __assign(__assign({}, getBaseTicketData(event.data)), { selected_article_id: event.data.article.id, selected_article_name: event.data.article.title, source_article_id: maybeGetArticleId(event.data.sourceArticle) });
                return logger.report(publicSuggestedArticlesClick(__assign(__assign({}, base), articleSelectedData)));
            }
            case PublicEventType.ARTICLE_ENGAGEMENT_PING: {
                var articleEngagementPingData = {
                    activity_type: event.data.activityType.length ? event.data.activityType.sort().join() : '',
                    article_id: event.data.article.id,
                    article_name: event.data.article.title,
                };
                return logger.report(publicUserArticleEngagementPing(__assign(__assign({}, base), articleEngagementPingData)));
            }
            case PublicEventType.AB_TESTING: {
                var eventData = event.data;
                return logger.report(abTestConductionCheckEvent(__assign(__assign({}, base), { is_b: eventData.isB, petri_conduciton_value: eventData.petriConducitonValue })));
            }
            default:
                return Promise.resolve();
        }
    };
};
//# sourceMappingURL=wix-public.js.map